<template>
  <section class="events-filters">
    <div class="container">
      <div
        class="filters-row"
        :class="{ opened: menuOpen }"
      >
        <div class="filter-tags-wrapper">
          <div class="title-wrapper">
            <p class="title">Explore popular categories by</p>
            <ChevronDownIcon
              class="chevron-down"
              @click="toggleMenu()"
            />
          </div>
          <div class="filter-tags">
            <FilterButton
              v-for="(tag, index) in tags"
              :key="index"
              :filter-title="tag.title"
              :is-active="isTagActive(tag.slug)"
              :show-close-icon="'all-events' !== tag.slug"
              @filter-clicked="setActiveTag(tag.slug)"
              @clear-filter="clearActiveTag"
            />
          </div>
        </div>
        <DatePicker
          class="date-picker"
          @set-date="setDate"
        />
      </div>
    </div>
  </section>
</template>

<script>
import DatePicker from '../DatePicker/DatePicker.vue';
import FilterButton from '~/components/Common/UI/FilterButton/FilterButton.vue';
import ChevronDownIcon from '~/components/Common/Svg/ChevronDownIcon.vue';
import { useEventsStore, DEFAULT_TAG_SLUG } from '~/stores/events.js';
export default {
  components: {
    DatePicker,
    ChevronDownIcon,
    FilterButton,
  },
  data() {
    return {
      menuOpen: false,
      eventsStore: useEventsStore(),
    };
  },
  computed: {
    tags() {
      return this.eventsStore.tags;
    },
    activeTag() {
      return this.eventsStore.tag;
    },
    date() {
      return this.eventsStore.date;
    },
  },
  mounted() {
    this.updateParams(this.activeTag, this.date);
  },
  methods: {
    isTagActive(slug) {
      return (
        slug === this.activeTag ||
        (!this.activeTag && slug === DEFAULT_TAG_SLUG)
      );
    },
    updateParams(tag = null, date = null) {
      const currentQuery = { ...this.$route.query };

      if (!date) {
        this.eventsStore.setDate(null);
        delete currentQuery.date;
      } else {
        currentQuery.date = date;
        this.eventsStore.setDate(date);
      }

      if (!tag || tag === DEFAULT_TAG_SLUG) {
        this.eventsStore.setTag(null);
        delete currentQuery.tag;
      } else {
        currentQuery.tag = tag;
        this.eventsStore.setTag(tag);
      }

      this.$router.push({ query: currentQuery });
    },
    clearActiveTag(event) {
      event.stopPropagation();

      this.updateParams(DEFAULT_TAG_SLUG, this.date);
    },
    setActiveTag(tagSlug) {
      this.updateParams(tagSlug, this.date);
    },
    setDate(date) {
      this.updateParams(this.activeTag, date);
    },
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './EventsFilters.scss';
</style>
